import { Box, Badge, Image, StarIcon, Text } from "@chakra-ui/react";
import React from "react";
import { Grid } from "@chakra-ui/react";
import { Single_Card } from "./Menu-single";
import {
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Stack,
} from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/react";
import Loader from "./loader";
import { Progress } from "@chakra-ui/react";
function AirbnbCard() {
  const [products, setProducts] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const fetching = async () => {
    let res = await fetch(`https://thin-fan-waiter.glitch.me/products`);
    let data = await res.json();
    setLoader(false);
    setProducts(data);
  };
  React.useEffect(() => {
    fetching();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <Grid
      templateColumns={{
        base: "repeat(1,1fr)",
        sm: "repeat(2,1fr)",
        md: "repeat(3,1fr)",
      }}
      gap={6}
    >
      {products.map((el, i) => (
        <Single_Card
          id={el.id}
          image={el.images}
          name={el.name}
          price={el.price}
          type={el.type}
          description={el.description}
        />
      ))}
    </Grid>
  );
}
export default AirbnbCard;
